<template>
    <div v-if="live" class="live-70-years">
        <div class="embed-responsive embed-responsive-16by9" v-html="live.embedVideo"></div>
        <div class="feed-live">
            <div class="live-signal">
                <div class="special-btn">En Vivo</div>
                <div class="concentric-waves">
                    <div class="point"></div>
                    <div class="spinner-item"></div>
                    <div class="spinner-item spinner-item-2"></div>
                    <div class="spinner-item spinner-item-3"></div>
                </div>
            </div>

            <text-fill v-cloak group-name="lsy" :max-font-size="20">
                {{ live.title }}
            </text-fill>
            <div class="feeds" v-if="live.feedTitle && live.feed && live.feed.length">
                <div>
                    <div v-for="(item, index) in live.feed" :key="index">
                        <span class="hour" v-html="item.time"></span>
                        <img v-if="item.image" :src="item.image.url" :alt="item.image.alt" />
                        <div v-html="item.content"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { TextFill } from "./../text-fill/TextFill.vue";
export default {
    components: { TextFill },
    props: {
        loadLive: Boolean,
    },
    created: function () {
        this.init();
        if (this.loadLive) {
            this.getLive();
        }
    },
    updated: function () {
        if (this.live) {
            document.dispatchEvent(window.lrLoad);
        }
    },
    computed: {
        ...mapGetters("live", {
            live: "data",
        }),
    },
    methods: {
        ...mapActions("live", {
            init: "init",
            getLive: "getLive",
        }),
    },
};
</script>